import {Component, Input, OnInit, ViewEncapsulation} from '@angular/core';
import {Subject} from 'rxjs';
import {Room} from '../../../classes/Room';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {RoomType} from '../../../enums/RoomType';
import {Office} from '../../../classes/Office';
import {OfficeService} from '../../../services/office.service';
import {RoomColor} from '../../../enums/RoomColor';
import {DomSanitizer, SafeUrl} from '@angular/platform-browser';
import {RoomService} from '../../../services/room.service';
import { getRoomColorHex, getRoomColorTextHex } from '../../../util/room-color.util';

@Component({
  selector: 'app-room-edit',
  styleUrls: ['./room-edit.component.scss'],
  templateUrl: './room-edit.component.html',
  encapsulation: ViewEncapsulation.None
})
export class RoomEditComponent implements OnInit {

  @Input() room: Room;

  destroy = new Subject<any>();
  currentDialog = null;
  errorMessage: string;
  offices: Office[];
  types = Object.keys(RoomType);
  colors = Object.keys(RoomColor);
  image: string | SafeUrl = '';
  imageLoaded = false;

  public roomForm: FormGroup;

  constructor(private activeModal: NgbActiveModal,
              private formBuilder: FormBuilder,
              private officeService: OfficeService,
              private sanitizer: DomSanitizer,
              private roomService: RoomService) {}

  ngOnInit(): void {

    this.officeService.getAll().subscribe({
      next: (response: Office[]) => this.offices = response,
      error: err => console.log(err.error) // TODO handle error
    });

    if (this.room) {
      if (this.room.image) {
        this.image = this.sanitizer.bypassSecurityTrustUrl(this.room.image);
        this.imageLoaded = true;
      }
      this.roomForm = this.formBuilder.group({
        id: [this.room.id],
        name: [this.room.name, Validators.required],
        nameHe: [this.room.nameHe, Validators.required],
        type: [this.room.type, Validators.required],
        officeId: [this.room.officeId, Validators.required],
        color: [this.room.color],
        area: [this.room.area],
        capacity: [this.room.capacity],
        imageFile: [this.room.image],
        description: [this.room.description]
      });
    } else {
      this.roomForm = this.formBuilder.group({
        id: [null],
        name: [null, Validators.required],
        nameHe: [null, Validators.required],
        type: [null, Validators.required],
        officeId: [null, Validators.required],
        color: [null],
        area: [null],
        capacity: [null],
        imageFile: [null],
        description: [null]
      });
    }
  }

  closeModal(sendData): void {
    this.activeModal.close(sendData);
  }

  onFileChange(event): void {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.image = this.sanitizer.bypassSecurityTrustUrl(window.URL.createObjectURL(file));
      this.roomForm.controls.imageFile.setValue(file);
    }
  }

  deleteImage(id: number): void {
    this.roomService.deleteImage(id).subscribe({
      next: () => {
        this.image = '';
        this.imageLoaded = false;
      }
    });
  }

  getColorOptionStyle(color: string): Record<string, string> {
    return {
      'background-color': getRoomColorHex(color),
      color: getRoomColorTextHex(color)
    };
  }
}
